import PropTypes from 'prop-types';
import React from 'react';

import {
  addMinutesToClock,
  formatClock12,
  formatDurationLabel,
  getAppointmentTypeColor,
} from '../../helpers';
import styles from './BookingRail.module.scss';

const BookingRail = ({ time, durationMinutes, appointmentTypeId, zone, compact = false }) => {
  const endTime = addMinutesToClock(time, durationMinutes);
  const colors = getAppointmentTypeColor({ appointmentTypeId });
  const [startClock, startMeridiem] = formatClock12(time).split(' ');

  return (
    <div
      className={`${styles.rail} ${compact ? styles.compact : ''}`}
      aria-label={`${formatClock12(time)} to ${formatClock12(endTime)}${zone ? ` ${zone}` : ''}`}
    >
      <span className={styles.start}>
        {startClock}
        <span className={styles.stack}>
          <span className={styles.meridiem}>{startMeridiem}</span>
          {zone && <span className={styles.zone}>{zone}</span>}
        </span>
      </span>
      <span
        aria-hidden="true"
        className={styles.block}
        style={{
          height: Math.max(durationMinutes, 26),
          borderLeftColor: colors.border,
          background: colors.bg,
          color: colors.text,
        }}
      >
        {formatDurationLabel(durationMinutes)}
      </span>
      <span className={styles.end}>
        {formatClock12(endTime)}
        {zone && <span className={styles.zone}> {zone}</span>}
      </span>
    </div>
  );
};

BookingRail.propTypes = {
  time: PropTypes.string.isRequired,
  durationMinutes: PropTypes.number.isRequired,
  appointmentTypeId: PropTypes.string,
  zone: PropTypes.string,
  compact: PropTypes.bool,
};

export default BookingRail;
